// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleChoice-module__font-s-10___JiHqe {
  font-size: 10px !important;
}

.SingleChoice-module__font-s-12___bH8yD {
  font-size: 12px !important;
}

.SingleChoice-module__font-s-13___qAlZ4 {
  font-size: 13px !important;
}

.SingleChoice-module__font-s-14___EkjMJ {
  font-size: 14px !important;
}

.SingleChoice-module__font-s-15___vrogi {
  font-size: 15px !important;
}

.SingleChoice-module__font-s-16___CGl4N {
  font-size: 16px !important;
}

.SingleChoice-module__font-s-18___n4pVT {
  font-size: 18px !important;
}

.SingleChoice-module__font-s-20___ZoZfe {
  font-size: 20px !important;
}

.SingleChoice-module__font-s-22___tJhvs {
  font-size: 22px !important;
}

.SingleChoice-module__font-s-28___KZJmr {
  font-size: 28px !important;
}

.SingleChoice-module__font-w-400___S1ntR {
  font-weight: 400 !important;
}

.SingleChoice-module__font-w-500___zERER {
  font-weight: 500 !important;
}

.SingleChoice-module__font-w-600____9AKT {
  font-weight: 600 !important;
}

.SingleChoice-module__font-w-700___MNrgR {
  font-weight: 700 !important;
}

.SingleChoice-module__p-5___A8SmP {
  padding: 5px !important;
}

.SingleChoice-module__p-12___FPhZH {
  padding: 12px !important;
}

.SingleChoice-module__p-16___rNjPV {
  padding: 16px !important;
}

.SingleChoice-module__p-30___zCjOv {
  padding: 30px !important;
}

.SingleChoice-module__p-b-0___Th_Ra {
  padding-bottom: 0 !important;
}

.SingleChoice-module__p-b-5___6KrY8 {
  padding-bottom: 5px !important;
}

.SingleChoice-module__p-b-10___xbRSo {
  padding-bottom: 10px !important;
}

.SingleChoice-module__p-b-12___JpxlX {
  padding-bottom: 12px !important;
}

.SingleChoice-module__p-b-16___WDgqk {
  padding-bottom: 16px !important;
}

.SingleChoice-module__p-b-18____fBuf {
  padding-bottom: 18px !important;
}

.SingleChoice-module__p-b-20___ORau_ {
  padding-bottom: 20px !important;
}

.SingleChoice-module__p-b-25___yMLYw {
  padding-bottom: 25px !important;
}

.SingleChoice-module__p-b-30___zbYCA {
  padding-bottom: 30px !important;
}

.SingleChoice-module__p-b-50___J17WO {
  padding-bottom: 50px !important;
}

.SingleChoice-module__p-t-0___aquo2 {
  padding-top: 0 !important;
}

.SingleChoice-module__p-t-12___a3Oiq {
  padding-top: 12px !important;
}

.SingleChoice-module__p-t-16___LQOTa {
  padding-top: 16px !important;
}

.SingleChoice-module__p-t-18___ZQb_P {
  padding-top: 18px !important;
}

.SingleChoice-module__p-t-20___EFwM5 {
  padding-top: 20px !important;
}

.SingleChoice-module__p-t-30___kn8Vx {
  padding-top: 30px !important;
}

.SingleChoice-module__p-t-40___kbTFT {
  padding-top: 40px !important;
}

.SingleChoice-module__p-t-50___eMITV {
  padding-top: 50px !important;
}

.SingleChoice-module__p-l-20___dziF0 {
  padding-left: 20px !important;
}

.SingleChoice-module__p-l-30___gi4ms {
  padding-left: 30px !important;
}

.SingleChoice-module__p-l-40___jSDW7 {
  padding-left: 40px !important;
}

.SingleChoice-module__p-r-16___peQgk {
  padding-right: 16px !important;
}

.SingleChoice-module__p-r-20___YfrYR {
  padding-right: 20px !important;
}

.SingleChoice-module__p-r-30___WdfRR {
  padding-right: 30px !important;
}

.SingleChoice-module__p-r-50___Gbo3q {
  padding-right: 50px !important;
}

.SingleChoice-module__p-r-60___tx9Vo {
  padding-right: 60px !important;
}

.SingleChoice-module__m-b-1___vwueK {
  margin-bottom: 1px !important;
}

.SingleChoice-module__m-b-2___k4y2U {
  margin-bottom: 2px !important;
}

.SingleChoice-module__m-b-6___GDUeE {
  margin-bottom: 6px !important;
}

.SingleChoice-module__m-b-8___AUFmu {
  margin-bottom: 8px !important;
}

.SingleChoice-module__m-b-10___jOKQq {
  margin-bottom: 10px !important;
}

.SingleChoice-module__m-b-14___kTyAa {
  margin-bottom: 14px !important;
}

.SingleChoice-module__m-b-16___IAGrw {
  margin-bottom: 16px !important;
}

.SingleChoice-module__m-b-20___f0ZuF {
  margin-bottom: 20px !important;
}

.SingleChoice-module__m-b-22___Bymzo {
  margin-bottom: 22px !important;
}

.SingleChoice-module__m-b-24___DM2vC {
  margin-bottom: 24px !important;
}

.SingleChoice-module__m-b-30___yFlDP {
  margin-bottom: 30px !important;
}

.SingleChoice-module__m-b-32___XmCJo {
  margin-bottom: 32px !important;
}

.SingleChoice-module__m-b-40___vc7jg {
  margin-bottom: 40px !important;
}

.SingleChoice-module__m-t-2___Ksib5 {
  margin-top: 2px !important;
}

.SingleChoice-module__m-t-3___kNmxE {
  margin-top: 3px !important;
}

.SingleChoice-module__m-t-4___Eo0Hf {
  margin-top: 4px !important;
}

.SingleChoice-module__m-t-5___KUCch {
  margin-top: 5px !important;
}

.SingleChoice-module__m-t-8___xvH23 {
  margin-top: 8px !important;
}

.SingleChoice-module__m-t-10___YVUI8 {
  margin-top: 10px !important;
}

.SingleChoice-module__m-t-15___ptRVy {
  margin-top: 15px !important;
}

.SingleChoice-module__m-t-16___h_t4Y {
  margin-top: 16px !important;
}

.SingleChoice-module__m-t-20___Zzg7A {
  margin-top: 20px !important;
}

.SingleChoice-module__m-t-22___Jhv8Z {
  margin-top: 22px !important;
}

.SingleChoice-module__m-t-30___UAnMm {
  margin-top: 30px !important;
}

.SingleChoice-module__m-t-32___J6utE {
  margin-top: 32px !important;
}

.SingleChoice-module__m-l-auto___XX_bl {
  margin-left: auto !important;
}

.SingleChoice-module__m-l-4___NNMDj {
  margin-left: 4px !important;
}

.SingleChoice-module__m-l-5___zpn5H {
  margin-left: 5px !important;
}

.SingleChoice-module__m-l-6___yBf05 {
  margin-left: 6px !important;
}

.SingleChoice-module__m-l-8___OmXTF {
  margin-left: 8px !important;
}

.SingleChoice-module__m-l-10___SruWT {
  margin-left: 10px !important;
}

.SingleChoice-module__m-l-16___Ske4V {
  margin-left: 16px !important;
}

.SingleChoice-module__m-l-20___sgnJo {
  margin-left: 20px !important;
}

.SingleChoice-module__m-l-24___mHe9N {
  margin-left: 24px !important;
}

.SingleChoice-module__m-l-30___oQhXG {
  margin-left: 30px !important;
}

.SingleChoice-module__m-l-35___r1Tk8 {
  margin-left: 35px !important;
}

.SingleChoice-module__m-l-40___UxQFd {
  margin-left: 40px !important;
}

.SingleChoice-module__m-r-8___Bbndj {
  margin-right: 8px !important;
}

.SingleChoice-module__m-r-10___uJuLZ {
  margin-right: 10px !important;
}

.SingleChoice-module__m-r-16___ifrPJ {
  margin-right: 16px !important;
}

.SingleChoice-module__m-r-20___F5Q0W {
  margin-right: 20px !important;
}

.SingleChoice-module__m-r-24___nlRkJ {
  margin-right: 24px !important;
}

.SingleChoice-module__m-r-30___QeeIw {
  margin-right: 30px !important;
}

.SingleChoice-module__m-r-40___dVot6 {
  margin-right: 40px !important;
}

.SingleChoice-module__border-r-3___cehXe {
  border-radius: 3px !important;
}

.SingleChoice-module__border-r-4___X38LC {
  border-radius: 4px !important;
}

.SingleChoice-module__border-r-6___oEcwe {
  border-radius: 6px !important;
}

.SingleChoice-module__border-r-10___nrZ5i {
  border-radius: 10px !important;
}

.SingleChoice-module__border-r-12___byuNq {
  border-radius: 12px !important;
}

.SingleChoice-module__border-r-16___g8WjA {
  border-radius: 16px !important;
}

.SingleChoice-module__border-r-50___HC1xJ {
  border-radius: 50% !important;
}

.SingleChoice-module__primary-border___IefEe {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleChoice-module__primary-border-b___iBiwl {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleChoice-module__primary-border-t___w2GUU {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleChoice-module__primary-border-l___WRhpf {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleChoice-module__primary-border-r___qXzMy {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SingleChoice-module__secondary-border___OfO3_ {
  border: 1px solid #637768;
}

.SingleChoice-module__secondary-border-b___ZR20Y {
  border-bottom: 1px solid #637768;
}

.SingleChoice-module__secondary-border-t___Yhtci {
  border-top: 1px solid #637768;
}

.SingleChoice-module__secondary-border-l___YkvKg {
  border-left: 1px solid #637768;
}

.SingleChoice-module__secondary-border-r___CcL5s {
  border-right: 1px solid #637768;
}

.SingleChoice-module__gap-0___TBu_m {
  gap: 0 !important;
}

.SingleChoice-module__gap-2___oBju0 {
  gap: 2px !important;
}

.SingleChoice-module__gap-4___dHm8v {
  gap: 4px !important;
}

.SingleChoice-module__gap-5___j4G3n {
  gap: 5px !important;
}

.SingleChoice-module__gap-6___isJ_V {
  gap: 6px !important;
}

.SingleChoice-module__gap-8___fZgKU {
  gap: 8px !important;
}

.SingleChoice-module__gap-10___Ghrsf {
  gap: 10px !important;
}

.SingleChoice-module__gap-12___lYl_P {
  gap: 12px !important;
}

.SingleChoice-module__gap-14___yBwEt {
  gap: 14px !important;
}

.SingleChoice-module__gap-16___kqyOU {
  gap: 16px !important;
}

.SingleChoice-module__gap-18____xUmV {
  gap: 18px !important;
}

.SingleChoice-module__gap-20___F_5eX {
  gap: 20px !important;
}

.SingleChoice-module__gap-24___GK048 {
  gap: 24px !important;
}

.SingleChoice-module__gap-26___y8A8k {
  gap: 26px !important;
}

.SingleChoice-module__gap-30___JfJo5 {
  gap: 30px !important;
}

.SingleChoice-module__gap-32___E2TNh {
  gap: 32px !important;
}

.SingleChoice-module__gap-40___x7vXH {
  gap: 40px !important;
}

.SingleChoice-module__gap-50___YCsl_ {
  gap: 50px !important;
}

.SingleChoice-module__flex-1___9Nak6 {
  flex: 1;
}

.SingleChoice-module__flex-none___Yiclb {
  flex: none !important;
}

.SingleChoice-module__flex-column___F7aHR {
  display: flex;
  flex-direction: column !important;
}

.SingleChoice-module__flex-row___kjTPl {
  display: flex;
  flex-direction: row !important;
}

.SingleChoice-module__vertically-centered___tbWwU {
  display: flex;
  align-items: center !important;
}

.SingleChoice-module__horizontally-centered___YmLDG {
  display: flex;
  justify-content: center !important;
}

.SingleChoice-module__horizontally-end___qg3Bv {
  display: flex;
  justify-content: end !important;
}

.SingleChoice-module__vertically-start___BNIB6 {
  display: flex;
  align-items: start !important;
}

.SingleChoice-module__space-between___CHVnc {
  display: flex;
  justify-content: space-between !important;
}

.SingleChoice-module__flex-wrap___Fh5FZ {
  flex-wrap: wrap !important;
}

.SingleChoice-module__height-100___tNXd1 {
  height: 100%;
}

.SingleChoice-module__width-50___CEKbP {
  width: 50% !important;
}

.SingleChoice-module__width-100___a2EZb {
  width: 100%;
}

.SingleChoice-module__cursor-pointer___Jj3rq {
  cursor: pointer;
}

.SingleChoice-module__cursor-not-allowed___UIZ5T {
  cursor: not-allowed !important;
}

.SingleChoice-module__absolute-centered___eHCgu {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SingleChoice-module__absolute___OcXwd {
  position: absolute;
}

.SingleChoice-module__relative____Svch {
  position: relative;
}

.SingleChoice-module__fixed___NW8Jx {
  position: fixed;
}

.SingleChoice-module__visible___jJav2 {
  opacity: 1;
}

.SingleChoice-module__invisible___yUnm1 {
  opacity: 0;
}

.SingleChoice-module__col-90___xsxDZ {
  width: 90% !important;
}

.SingleChoice-module__col-auto___lhq4B {
  width: auto !important;
}

.SingleChoice-module__medical-tabs___r4uap {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SingleChoice-module__medical-table-new___Nhicp {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SingleChoice-module__medical-table-new___Nhicp:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SingleChoice-module__medical-table-new___Nhicp::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SingleChoice-module__medical-table-new___Nhicp::-webkit-scrollbar-track {
  display: none;
}
.SingleChoice-module__medical-table-new___Nhicp.SingleChoice-module__no-pagination___J3nDJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SingleChoice-module__medical-table-new___Nhicp.SingleChoice-module__no-pagination___J3nDJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SingleChoice-module__medical-table-new___Nhicp.SingleChoice-module__no-pagination___J3nDJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SingleChoice-module__medical-table-new___Nhicp.SingleChoice-module__no-pagination___J3nDJ::-webkit-scrollbar-track {
  display: none;
}

.SingleChoice-module__medical-table-empty___Q0YyX {
  padding: 14px 40px !important;
}

.SingleChoice-module__icon-btn___siXI_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SingleChoice-module__search-icon___EqfnH {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SingleChoice-module__disable-select___Ie7Ut {
  user-select: none;
}

.SingleChoice-module__break-word___dEMM3 {
  word-break: break-word;
}

.SingleChoice-module__popup-clear-btn___cL5cO {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SingleChoice-module__scroll-m-b-20___q92FG {
  scroll-margin-bottom: 20px;
}

.SingleChoice-module__container___S_2po {
  justify-content: space-between;
}
.SingleChoice-module__container___S_2po .SingleChoice-module__label___bYjfM {
  color: #375844;
}
.SingleChoice-module__container___S_2po .SingleChoice-module__label___bYjfM.SingleChoice-module__disabled___vNg07 {
  opacity: 0.6;
}
.SingleChoice-module__container___S_2po .SingleChoice-module__choices___gq03O {
  display: flex;
  align-items: flex-end;
}
.SingleChoice-module__container___S_2po .SingleChoice-module__choices___gq03O .SingleChoice-module__button___Maom8 {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/SingleChoice/SingleChoice.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,8BAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA5pBI;EACE,YAAA;AA8pBN;AA1pBE;EACE,aAAA;EACA,qBAAA;AA4pBJ;AA1pBI;EACE,UAAA;AA4pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  justify-content: space-between;\n\n  .label {\n    color: get-color(greenNew, dark);\n\n    &.disabled {\n      opacity: 0.6;\n    }\n  }\n\n  .choices {\n    display: flex;\n    align-items: flex-end;\n\n    .button {\n      padding: 0;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SingleChoice-module__font-s-10___JiHqe`,
	"fontS12": `SingleChoice-module__font-s-12___bH8yD`,
	"fontS13": `SingleChoice-module__font-s-13___qAlZ4`,
	"fontS14": `SingleChoice-module__font-s-14___EkjMJ`,
	"fontS15": `SingleChoice-module__font-s-15___vrogi`,
	"fontS16": `SingleChoice-module__font-s-16___CGl4N`,
	"fontS18": `SingleChoice-module__font-s-18___n4pVT`,
	"fontS20": `SingleChoice-module__font-s-20___ZoZfe`,
	"fontS22": `SingleChoice-module__font-s-22___tJhvs`,
	"fontS28": `SingleChoice-module__font-s-28___KZJmr`,
	"fontW400": `SingleChoice-module__font-w-400___S1ntR`,
	"fontW500": `SingleChoice-module__font-w-500___zERER`,
	"fontW600": `SingleChoice-module__font-w-600____9AKT`,
	"fontW700": `SingleChoice-module__font-w-700___MNrgR`,
	"p5": `SingleChoice-module__p-5___A8SmP`,
	"p12": `SingleChoice-module__p-12___FPhZH`,
	"p16": `SingleChoice-module__p-16___rNjPV`,
	"p30": `SingleChoice-module__p-30___zCjOv`,
	"pB0": `SingleChoice-module__p-b-0___Th_Ra`,
	"pB5": `SingleChoice-module__p-b-5___6KrY8`,
	"pB10": `SingleChoice-module__p-b-10___xbRSo`,
	"pB12": `SingleChoice-module__p-b-12___JpxlX`,
	"pB16": `SingleChoice-module__p-b-16___WDgqk`,
	"pB18": `SingleChoice-module__p-b-18____fBuf`,
	"pB20": `SingleChoice-module__p-b-20___ORau_`,
	"pB25": `SingleChoice-module__p-b-25___yMLYw`,
	"pB30": `SingleChoice-module__p-b-30___zbYCA`,
	"pB50": `SingleChoice-module__p-b-50___J17WO`,
	"pT0": `SingleChoice-module__p-t-0___aquo2`,
	"pT12": `SingleChoice-module__p-t-12___a3Oiq`,
	"pT16": `SingleChoice-module__p-t-16___LQOTa`,
	"pT18": `SingleChoice-module__p-t-18___ZQb_P`,
	"pT20": `SingleChoice-module__p-t-20___EFwM5`,
	"pT30": `SingleChoice-module__p-t-30___kn8Vx`,
	"pT40": `SingleChoice-module__p-t-40___kbTFT`,
	"pT50": `SingleChoice-module__p-t-50___eMITV`,
	"pL20": `SingleChoice-module__p-l-20___dziF0`,
	"pL30": `SingleChoice-module__p-l-30___gi4ms`,
	"pL40": `SingleChoice-module__p-l-40___jSDW7`,
	"pR16": `SingleChoice-module__p-r-16___peQgk`,
	"pR20": `SingleChoice-module__p-r-20___YfrYR`,
	"pR30": `SingleChoice-module__p-r-30___WdfRR`,
	"pR50": `SingleChoice-module__p-r-50___Gbo3q`,
	"pR60": `SingleChoice-module__p-r-60___tx9Vo`,
	"mB1": `SingleChoice-module__m-b-1___vwueK`,
	"mB2": `SingleChoice-module__m-b-2___k4y2U`,
	"mB6": `SingleChoice-module__m-b-6___GDUeE`,
	"mB8": `SingleChoice-module__m-b-8___AUFmu`,
	"mB10": `SingleChoice-module__m-b-10___jOKQq`,
	"mB14": `SingleChoice-module__m-b-14___kTyAa`,
	"mB16": `SingleChoice-module__m-b-16___IAGrw`,
	"mB20": `SingleChoice-module__m-b-20___f0ZuF`,
	"mB22": `SingleChoice-module__m-b-22___Bymzo`,
	"mB24": `SingleChoice-module__m-b-24___DM2vC`,
	"mB30": `SingleChoice-module__m-b-30___yFlDP`,
	"mB32": `SingleChoice-module__m-b-32___XmCJo`,
	"mB40": `SingleChoice-module__m-b-40___vc7jg`,
	"mT2": `SingleChoice-module__m-t-2___Ksib5`,
	"mT3": `SingleChoice-module__m-t-3___kNmxE`,
	"mT4": `SingleChoice-module__m-t-4___Eo0Hf`,
	"mT5": `SingleChoice-module__m-t-5___KUCch`,
	"mT8": `SingleChoice-module__m-t-8___xvH23`,
	"mT10": `SingleChoice-module__m-t-10___YVUI8`,
	"mT15": `SingleChoice-module__m-t-15___ptRVy`,
	"mT16": `SingleChoice-module__m-t-16___h_t4Y`,
	"mT20": `SingleChoice-module__m-t-20___Zzg7A`,
	"mT22": `SingleChoice-module__m-t-22___Jhv8Z`,
	"mT30": `SingleChoice-module__m-t-30___UAnMm`,
	"mT32": `SingleChoice-module__m-t-32___J6utE`,
	"mLAuto": `SingleChoice-module__m-l-auto___XX_bl`,
	"mL4": `SingleChoice-module__m-l-4___NNMDj`,
	"mL5": `SingleChoice-module__m-l-5___zpn5H`,
	"mL6": `SingleChoice-module__m-l-6___yBf05`,
	"mL8": `SingleChoice-module__m-l-8___OmXTF`,
	"mL10": `SingleChoice-module__m-l-10___SruWT`,
	"mL16": `SingleChoice-module__m-l-16___Ske4V`,
	"mL20": `SingleChoice-module__m-l-20___sgnJo`,
	"mL24": `SingleChoice-module__m-l-24___mHe9N`,
	"mL30": `SingleChoice-module__m-l-30___oQhXG`,
	"mL35": `SingleChoice-module__m-l-35___r1Tk8`,
	"mL40": `SingleChoice-module__m-l-40___UxQFd`,
	"mR8": `SingleChoice-module__m-r-8___Bbndj`,
	"mR10": `SingleChoice-module__m-r-10___uJuLZ`,
	"mR16": `SingleChoice-module__m-r-16___ifrPJ`,
	"mR20": `SingleChoice-module__m-r-20___F5Q0W`,
	"mR24": `SingleChoice-module__m-r-24___nlRkJ`,
	"mR30": `SingleChoice-module__m-r-30___QeeIw`,
	"mR40": `SingleChoice-module__m-r-40___dVot6`,
	"borderR3": `SingleChoice-module__border-r-3___cehXe`,
	"borderR4": `SingleChoice-module__border-r-4___X38LC`,
	"borderR6": `SingleChoice-module__border-r-6___oEcwe`,
	"borderR10": `SingleChoice-module__border-r-10___nrZ5i`,
	"borderR12": `SingleChoice-module__border-r-12___byuNq`,
	"borderR16": `SingleChoice-module__border-r-16___g8WjA`,
	"borderR50": `SingleChoice-module__border-r-50___HC1xJ`,
	"primaryBorder": `SingleChoice-module__primary-border___IefEe`,
	"primaryBorderB": `SingleChoice-module__primary-border-b___iBiwl`,
	"primaryBorderT": `SingleChoice-module__primary-border-t___w2GUU`,
	"primaryBorderL": `SingleChoice-module__primary-border-l___WRhpf`,
	"primaryBorderR": `SingleChoice-module__primary-border-r___qXzMy`,
	"secondaryBorder": `SingleChoice-module__secondary-border___OfO3_`,
	"secondaryBorderB": `SingleChoice-module__secondary-border-b___ZR20Y`,
	"secondaryBorderT": `SingleChoice-module__secondary-border-t___Yhtci`,
	"secondaryBorderL": `SingleChoice-module__secondary-border-l___YkvKg`,
	"secondaryBorderR": `SingleChoice-module__secondary-border-r___CcL5s`,
	"gap0": `SingleChoice-module__gap-0___TBu_m`,
	"gap2": `SingleChoice-module__gap-2___oBju0`,
	"gap4": `SingleChoice-module__gap-4___dHm8v`,
	"gap5": `SingleChoice-module__gap-5___j4G3n`,
	"gap6": `SingleChoice-module__gap-6___isJ_V`,
	"gap8": `SingleChoice-module__gap-8___fZgKU`,
	"gap10": `SingleChoice-module__gap-10___Ghrsf`,
	"gap12": `SingleChoice-module__gap-12___lYl_P`,
	"gap14": `SingleChoice-module__gap-14___yBwEt`,
	"gap16": `SingleChoice-module__gap-16___kqyOU`,
	"gap18": `SingleChoice-module__gap-18____xUmV`,
	"gap20": `SingleChoice-module__gap-20___F_5eX`,
	"gap24": `SingleChoice-module__gap-24___GK048`,
	"gap26": `SingleChoice-module__gap-26___y8A8k`,
	"gap30": `SingleChoice-module__gap-30___JfJo5`,
	"gap32": `SingleChoice-module__gap-32___E2TNh`,
	"gap40": `SingleChoice-module__gap-40___x7vXH`,
	"gap50": `SingleChoice-module__gap-50___YCsl_`,
	"flex1": `SingleChoice-module__flex-1___9Nak6`,
	"flexNone": `SingleChoice-module__flex-none___Yiclb`,
	"flexColumn": `SingleChoice-module__flex-column___F7aHR`,
	"flexRow": `SingleChoice-module__flex-row___kjTPl`,
	"verticallyCentered": `SingleChoice-module__vertically-centered___tbWwU`,
	"horizontallyCentered": `SingleChoice-module__horizontally-centered___YmLDG`,
	"horizontallyEnd": `SingleChoice-module__horizontally-end___qg3Bv`,
	"verticallyStart": `SingleChoice-module__vertically-start___BNIB6`,
	"spaceBetween": `SingleChoice-module__space-between___CHVnc`,
	"flexWrap": `SingleChoice-module__flex-wrap___Fh5FZ`,
	"height100": `SingleChoice-module__height-100___tNXd1`,
	"width50": `SingleChoice-module__width-50___CEKbP`,
	"width100": `SingleChoice-module__width-100___a2EZb`,
	"cursorPointer": `SingleChoice-module__cursor-pointer___Jj3rq`,
	"cursorNotAllowed": `SingleChoice-module__cursor-not-allowed___UIZ5T`,
	"absoluteCentered": `SingleChoice-module__absolute-centered___eHCgu`,
	"absolute": `SingleChoice-module__absolute___OcXwd`,
	"relative": `SingleChoice-module__relative____Svch`,
	"fixed": `SingleChoice-module__fixed___NW8Jx`,
	"visible": `SingleChoice-module__visible___jJav2`,
	"invisible": `SingleChoice-module__invisible___yUnm1`,
	"col90": `SingleChoice-module__col-90___xsxDZ`,
	"colAuto": `SingleChoice-module__col-auto___lhq4B`,
	"medicalTabs": `SingleChoice-module__medical-tabs___r4uap`,
	"medicalTableNew": `SingleChoice-module__medical-table-new___Nhicp`,
	"noPagination": `SingleChoice-module__no-pagination___J3nDJ`,
	"medicalTableEmpty": `SingleChoice-module__medical-table-empty___Q0YyX`,
	"iconBtn": `SingleChoice-module__icon-btn___siXI_`,
	"searchIcon": `SingleChoice-module__search-icon___EqfnH`,
	"disableSelect": `SingleChoice-module__disable-select___Ie7Ut`,
	"breakWord": `SingleChoice-module__break-word___dEMM3`,
	"popupClearBtn": `SingleChoice-module__popup-clear-btn___cL5cO`,
	"scrollMB20": `SingleChoice-module__scroll-m-b-20___q92FG`,
	"container": `SingleChoice-module__container___S_2po`,
	"label": `SingleChoice-module__label___bYjfM`,
	"disabled": `SingleChoice-module__disabled___vNg07`,
	"choices": `SingleChoice-module__choices___gq03O`,
	"button": `SingleChoice-module__button___Maom8`
};
module.exports = ___CSS_LOADER_EXPORT___;
